import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorWarehouseDeliveryLinesSearch = () => {
  const deliveryLinesSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/delivery-lines/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { deliveryLinesSearch }
}

export default InteractorWarehouseDeliveryLinesSearch
